<template>
  <v-container>
    <material-wizard
      v-model="tab"
      title="Nova Importação SPED"
      subtitle="Selecione o tipo e codificação dos arquivos que serão importados"
      :available-steps="tabsLiberadas"
      :wizzardMixinsOn="true"
      :tabs="tabs"
      class="mx-auto"
      :loading="loading"
      maxWidth="870"
      @click:next="nextStep()"
      @click:prev="prevStep()"
    >
      <wizzard-tabs ref="impotacoesSped" :tab="tab" :importacaoId="importacaoId" @step-observer="updateTabStatus($event)" />
    </material-wizard>
  </v-container>
</template>

<script>
  import importacoesSpedService from '@/services/importacoesSpedService';
  import wizardMixins from '@/mixins/wizardMixins.js';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      MaterialWizard: () => import('@/components/base/MaterialWizard'),
      WizzardTabs: () => import('@/components/importacoesSped/WizzardTabs')
    },
    mixins: [wizardMixins, tourMixins],

    data: () => ({
      tabs: ['Informações Básicas', 'Upload de Arquivos'],
      loading: false,
      importacaoId: 0,
      arrPrimeiraTabTour: [
        {
          element: '#importacao-sped-infos-basicas',
          title: 'Informações Básicas',
          intro: 'Aqui você poderá escolher um nome para seu sua Importacao de Sped, selecionar o tipo e codificação.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ],
      arrSegundaTabTour: [
        {
          element: '#input-upload-importacoes-sped',
          title: 'Upload de Arquivos',
          intro: 'Aqui você poderá fazer upload dos arquivos no formato zip e txt.',
          scrollTo: 'tooltip',
          position: 'bottom'
        }
      ]
    }),

    mounted() {
      if (this.$route.params.id) {
        this.importacaoId = parseInt(this.$route.params.id);
      }
      this.iniciarPrimeiraTabTour();
    },

    methods: {
      nextStep() {
        if (this.tab === this.tabs.length - 1) {
          this.loading = true;
          const status = this.$refs.impotacoesSped.setUpdates();
          if (!status) this.loading = false;
        } else {
          this.salvar();
        }
        this.$forceUpdate();
      },

      salvar() {
        this.tab++;
        if (!this.importacaoId == 0) return;

        const data = this.$refs.impotacoesSped.exportData();
        importacoesSpedService
          .salvar(data)
          .then((resp) => {
            this.importacaoId = resp.data.importacao_id;
          })
          .catch((err) => {
            this.$toast.error('Erro ao salvar a Importações de SPED.', '', { position: 'topRight' });
            console.error(err);
          });
      },

      iniciarPrimeiraTabTour() {
        this.doneLabel = 'Proximo';
        this.desativarTourAoSair = false;

        let onBeforeExitFunction = {
          func: () => {
            this.tab = 1;
            this.iniciarSegundaTabTour();
          }
        };
        this.iniciarTour(this.arrPrimeiraTabTour, [], [], [onBeforeExitFunction]);
      },

      iniciarSegundaTabTour() {
        this.doneLabel = 'Finalizar';
        this.desativarTourAoSair = true;

        let onBeforeExitFunction = {
          func: () => (this.tab = 0)
        };

        this.iniciarTour(this.arrSegundaTabTour, [], [], [onBeforeExitFunction]);
      }
    }
  };
</script>